@if (inColumn) {
    <button
        ds-button
        kind="primary"
        variant="filled"
        size="large"
        truncate="true"
        class="betslip-close-button"
        [msAutomation]="'betslip-close-button'"
        (click)="return()">
        {{ messages.common.CloseBetslip }}
    </button>
} @else {
    <button
        ds-button
        msThemedButton
        kind="primary"
        variant="filled"
        size="large"
        truncate="true"
        class="betslip-back-button"
        [themeKind]="buttonThemeKind"
        [themeVariant]="buttonThemeVariant"
        [msAutomation]="'betslip-back-button'"
        (click)="return()">
        {{ messages.common.Return }}
    </button>
    <button
        ds-button
        kind="primary"
        variant="filled"
        size="large"
        truncate="true"
        class="betslip-close-button"
        [msAutomation]="'betslip-close-button'"
        (click)="close()">
        {{ messages.common.CloseBetslip }}
    </button>
}
